import { collection,getDocs, query, getDoc, doc, orderBy, where, QueryDocumentSnapshot, DocumentData, limit, startAfter, getCountFromServer } from "firebase/firestore";
import { db } from "../firebase";
import { PointCategory, PointHistoryData, pointDataTimestampToDate,} from "../model/PointData";

const master = "master";

const pointDataQuery = {  
  // ポイントカテゴリ一覧を取得
  getPointCategoryList: async () => {
    console.log("pointData getPointCategoryList access");
    const pointCategoryRef = await getDocs(
      query(
        collection(db, `pointData/${master}/pointCategory`),
        orderBy("sortKey", "asc")
      )
    );
    return pointCategoryRef.docs.map((doc) => doc.data() as PointCategory);
  },

  //ポイント履歴のデータを取得
  getPointHistoryData: async (tenantId: string, id:string) => {
    console.log("pointData getPointHistoryData access");
      const docsRef = await getDoc(doc(db, `pointData/${tenantId}/pointHistory`, id));
      return pointDataTimestampToDate(docsRef.data());
  },

  /**
   * 利用者ポイント履歴一覧をポイント発生日の降順で取得
   * @param tenantId テナントID
   * @param userId ユーザID
   * @param tranType 取引種別
   * @param listLimit データ取得件数
   * @param startAfterRecordDoc データ取得開始位置
   * @returns history：取得データ、finalDoc：最終データ
   */
  getUserPointHistoryListSort: async (
    tenantId: string, 
    userId: string,
    tranType: string,
    month: Date,
    listLimit: number,
    startAfterRecordDoc?: QueryDocumentSnapshot<DocumentData, DocumentData>
  ) => {
    console.log("pointData getUserPointHistoryListSort access");

    const queries: any[] = [
      where('userId', '==', userId),
      where("occurrenceDate", ">=", new Date(month.getFullYear(), month.getMonth(), 1, 0, 0)),
      where("occurrenceDate", "<=", new Date(month.getFullYear(), month.getMonth() + 1, 0, 23, 59)),
      orderBy('occurrenceDate', 'desc'),
    ];

    if (tranType === '利用') {
      queries.push(where('tranType', '==', '利用'))
    } else {
      queries.push(where('tranType', '!=', '利用'))
    }

    if (startAfterRecordDoc != undefined) {
      queries.push(startAfter(startAfterRecordDoc));
    }

    const docsRef = await getDocs(
      query(
        collection(db, `pointData/${tenantId}/pointHistory`),
        ...queries,
        limit(listLimit)
      )
    );

    const histories = docsRef.docs.map((doc: QueryDocumentSnapshot<DocumentData>) => {
      return (doc.data() as PointHistoryData);
    });

    const finalDoc = docsRef.docs[docsRef.docs.length -1];

    return {history: histories, finalDoc: finalDoc};
  },
  /**
   * 利用者ポイント履歴（tranType=付与,調整,失効）の件数を取得
   * @param tenantId テナントID
   * @param userId ユーザID
   * @returns データ件数
   */
  getUserPointHistoryGrantLength: async (tenantId: string, userId: string, month: Date) => {
    console.log("pointData getUserPointHistoryGrantLength access");
    const docsLength = await getCountFromServer(
      query(
        collection(db, `pointData/${tenantId}/pointHistory`),
        where('userId', '==', userId),
        where('tranType', '!=', '利用'),
        where("occurrenceDate", ">=", new Date(month.getFullYear(), month.getMonth(), 1, 0, 0)),
        where("occurrenceDate", "<=", new Date(month.getFullYear(), month.getMonth() + 1, 0, 23, 59)),
      )
    );
    return docsLength.data().count;
  },
  /**
   * 利用者ポイント履歴（tranType=利用）の件数を取得
   * @param tenantId テナントID
   * @param userId ユーザID
   * @returns データ件数
   */
  getUserPointHistoryUsageLength: async (tenantId: string, userId: string, month: Date) => {
    console.log("pointData getUserPointHistoryUsageLength access");
    const docsLength = await getCountFromServer(
      query(
        collection(db, `pointData/${tenantId}/pointHistory`),
        where('userId', '==', userId),
        where("occurrenceDate", ">=", new Date(month.getFullYear(), month.getMonth(), 1, 0, 0)),
        where("occurrenceDate", "<=", new Date(month.getFullYear(), month.getMonth() + 1, 0, 23, 59)),
        where('tranType', '==', '利用'),
      )
    );
    return docsLength.data().count;
  },
};

export default pointDataQuery;